import { IframeEvents } from './iframe-events';
export class IdentityAuth {
    init(root = document) {
        this._initIframeEventListeners(root);
    }
    _initIframeEventListeners(root) {
        const allowedOrigin = root.querySelector('#Login')?.dataset['origin'];
        if (!allowedOrigin) {
            this._logError('Allowed origin for LoginIFrame not found. Cannot initialize iframe event listeners.');
            return;
        }
        IframeEvents.initMessageListener(allowedOrigin, 'LoginIFrame');
    }
    _logError(message) {
        console.error(`IdentityAuth: ${message}`);
    }
}
